import { jsxs as i, jsx as o } from "react/jsx-runtime";
import s from "classnames";
import n from "styled-components";
import t from "../../utils/colors.js";
import { device as e } from "../../utils/device.js";
import c from "./Copyrights/Copyrights.js";
import a from "./Links/Links.js";
const m = n.footer`
  font-size: 0.9375rem;
  font-weight: normal;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  background-color: ${t.darkGrey};

  @media ${e.isTablet} {
    align-items: center;
    font-weight: normal;
  }

  @media ${e.isMobile} {
    font-size: 0.8125rem;
  }
`, f = n.div`
  padding: 40px 20px;
  border-bottom: 1px solid ${t.darkGrey75};
  color: ${t.white};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  span:first-child {
    font-weight: 500;
  }

  span:last-child {
    font-weight: normal;
  }

  @media ${e.isTablet}, ${e.isDesktop} {
    display: none;
  }
`, y = ({ showFooter: l, className: r = "" }) => l ? /* @__PURE__ */ i(m, { className: s({ [r]: !!r }), role: "contentinfo", children: [
  /* @__PURE__ */ i(f, { children: [
    /* @__PURE__ */ o("span", { children: "Service Victoria" }),
    /* @__PURE__ */ o("span", { children: "The new place to go for government services" })
  ] }),
  /* @__PURE__ */ o(a, {}),
  /* @__PURE__ */ o(c, {})
] }) : null;
export {
  y as default
};
